export default "<p>application-management works!</p>\n"